module.exports = __webpack_public_path__ + "pc/img/swiper0.2d385fb0.jpg";